import { render, staticRenderFns } from "./exchange-add.vue?vue&type=template&id=2a546cde&scoped=true"
import script from "./exchange-add.vue?vue&type=script&lang=js"
export * from "./exchange-add.vue?vue&type=script&lang=js"
import style0 from "./exchange-add.vue?vue&type=style&index=0&id=2a546cde&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a546cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a546cde')) {
      api.createRecord('2a546cde', component.options)
    } else {
      api.reload('2a546cde', component.options)
    }
    module.hot.accept("./exchange-add.vue?vue&type=template&id=2a546cde&scoped=true", function () {
      api.rerender('2a546cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/exchange/exchange-add.vue"
export default component.exports